import { render, staticRenderFns } from "./BlobBackground.vue?vue&type=template&id=3413da3e&scoped=true&"
import script from "./BlobBackground.vue?vue&type=script&lang=js&"
export * from "./BlobBackground.vue?vue&type=script&lang=js&"
import style0 from "./BlobBackground.vue?vue&type=style&index=0&id=3413da3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3413da3e",
  null
  
)

export default component.exports